// extracted by mini-css-extract-plugin
module.exports = {"breadcomb":"Breadcomb_breadcomb__2kwbB","rightArrow":"Breadcomb_rightArrow__iEotH","rightArrowSvg":"Breadcomb_rightArrowSvg__3mVVi"};